import getData from "@/__main__/get-data.mjs";
import { appURLs } from "@/app/constants.mjs";
import * as GraphQLTemplatesDatalake from "@/game-lol/graphql-templates-datalake.mjs";
import ChampionStats from "@/game-lol/models/lol-champion-arena.mjs";
import { queryGQL } from "@/util/gql-formatters.mjs";

export default function (championId: number, path: string[], options?: object) {
  return getData(
    queryGQL(appURLs.DATALAKE, GraphQLTemplatesDatalake.ArenaChampionStats, {
      championId: championId.toString(),
    }),
    ChampionStats,
    path || ["lol", "championArenaStats", championId],
    {
      ...(options || {}),
      // shouldFetchIfPathExists: false,
      // expiryTime: Date.now() + 2 * 60 * 60 * 1000, // 2 hours
    },
  );
}
